import angular from 'angular';
import { checkConfigStats } from './principal-check-config-stats.component';
import { checkConfig } from './principal-check-config.component';

(function() {
    'use strict';

    angular
        .module('app.principal', [])
        .component('principalCheckConfigStats', checkConfigStats)
        .component('principalCheckConfig', checkConfig);
})();
